import { defineMessages } from 'react-intl-next';

export default defineMessages({
    csmRequestsListBannerText: {
        defaultMessage: 'My requests',
        description: 'Text for the banner in the csm requests list page',
        id: 'hub.csm.requests.list.banner.text.non-final',
    },
});
